'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxAsyncConnect = require('redux-async-connect');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props, helpers, filter) {
  return _react2.default.createElement(_reduxAsyncConnect.ReduxAsyncConnect, (0, _extends3.default)({}, props, {
    helpers: helpers,
    filter: filter
  }));
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/redux/utils/getReduxAsyncComponent.jsx
// module id = 1306
// module chunks = 0